<style>
.proposedDraft {
	height: calc(100% - 258px + 40px);
}
</style>
<template>
	<div :class="draftClasses" v-if="proposedDraft">
		<div class="measure-container">
			<div class="measure-container-inner">
				<measure-node
					v-for="measure in proposedDraft.attached_measures"
					v-bind:key="measure.id"
					:srv-phase-id="phaseId"
					:actor-phase-properties="actorPhaseProperties"
					:measure="measure"
					:draft="proposedDraft"
					:post-decided-timeout-is-finished="postDecidedTimeoutIsFinished"
				></measure-node>
			</div>
			<div v-if="!postDecidedTimeoutIsFinished || autoCloseCountdown">
				<div
					class="draftStateStamp"
					v-if='proposedDraft["passed?"] || proposedDraft["failed?"]'
				>
					<img
						:src='"/img/unionslabor/odd_bits/stamp_" + (proposedDraft["passed?"] ? "passed" : "failed") + "_draft" + (isExternalEventDraft ? "_external" : "") + ".png"'
					>
				</div>
			</div>
		</div>
		<!-- @vue-expect-error -->
		<div
			v-if="!this.delayVoting || this.userVoted"
			class="draftRatings clearfix"
		>
			<div class="draftRating">
				<!-- @vue-expect-error -->
				<img src="/img/unionslabor/icons/check_green.svg" alt>
				<span v-for="rating in filterRatings(1)" v-bind:key="rating.id">
					<img
						:src='"/img/flags/" + rating.actor.name + ".svg"'
						style="height: 16px"
					>
				</span>
			</div>
			<div class="draftRating">
				<!-- @vue-expect-error -->
				<img src="/img/unionslabor/icons/cross_red.svg" alt>
				<span v-for="rating in filterRatings(-1)" v-bind:key="rating.id">
					<img
						:src='"/img/flags/" + rating.actor.name + ".svg"'
						style="height: 16px"
					>
				</span>
			</div>
		</div>
		<div
			v-if="(proposedDraft.voting_finished && !isExternalEventDraft) || (isExternalEventDraft && postDecidedTimeoutIsFinished && proposedDraft.voting_finished)"
			class="ulab-button ulab-button-interaction"
			style="text-align: center;"
			v-on:click="closeDraft()"
		>
			Weiter verhandeln ({{ autoCloseCountdownSeconds }})
		</div>
		<div
			v-if="!userVoted && processingUserVote"
			style="text-align: center; padding: 1em;"
		>
			Länderwerte werden berechnet.
		</div>
		<div
			v-if="userVoted && !proposedDraft.voting_finished"
			style="text-align: center; padding: 1em;"
		>
			Abstimmung läuft …
		</div>
		<div
			v-if="!userVoted && delayVoting"
			style="text-align: center; padding: 1em;"
		>
			Diskutiert über mögliche Konsequenzen!
		</div>
		<div
			class="clearfix"
			v-if="!delayVoting && !userVoted && !processingUserVote && !proposedDraft.voting_finished"
			style="text-align: center;"
		>
			<div
				class="ulab-button ulab-button-voting ulab-button-voting-for"
				v-on:click="(e) => voteDraft(e, 1)"
			>
				Dafür
			</div>
			<div
				class="ulab-button ulab-button-voting ulab-button-voting-against"
				v-on:click="(e) => voteDraft(e, -1)"
			>
				Dagegen
			</div>
		</div>
	</div>
</template>

<script>
// Other components
import { i18n } from "../utils";
import MeasureNode from "./measure_node.vue";

export default {
	// Naming - server = srv
	mixins: [i18n],
	props: {
		proposedDraft: Object,
		currentActorId: Number,
		actorPhaseProperties: Object,
		srvActorPropertiesGoal: Object,
		srvPhaseId: Number,
	},
	components: {
		"measure-node": MeasureNode,
	},
	data: function () {
		return {
			processingUserVote: false,
			delayVoting: false,
			delayVotingTimeoutSeconds: 20,
			postDecidedTimeoutIsFinished: false,
			postDecidedTimeoutSeconds: 2,
			autoCloseCountdown: null,
			autoCloseCountdownSeconds: 5,
		};
	},
	mounted: function () {
		// pp.log("isExternalEventDraft", this.isExternalEventDraft);
		if (this.isExternalEventDraft) {
			this.delayVoting = true;
			setTimeout(() => {
				this.delayVoting = false;
			}, this.delayVotingTimeoutSeconds * 1000);
		}
	},
	beforeDestroy: function () {
		if (this.autoCloseCountdown) {
			window.clearInterval(this.autoCloseCountdown);
			this.autoCloseCountdown = null;
		}
	},
	watch: {
		proposedDraft: function (newVal, oldVal) {
			// pp.log("TIMER", this.autoCloseCountdown, newVal, oldVal);
			this.clearCountDownInterval();
			if (newVal && newVal.voting_finished) {
				if (this.isExternalEventDraft) {
					window.setTimeout(() => {
						// pp.log("SETTING POST DECIDIE");
						this.initVotingModalCloseCountdown();
						this.postDecidedTimeoutIsFinished = true;
					}, this.postDecidedTimeoutSeconds * 1000);
				} else {
					this.initVotingModalCloseCountdown();
					this.postDecidedTimeoutIsFinished = false;
				}
			}
		},
	},
	computed: {
		phaseId: function () {
			return this.srvPhaseId !== undefined
				? this.srvPhaseId
				: pp.gameState.phaseId;
		},
		draftClasses: function () {
			let classes = "proposedDraft ";
			if (this.isExternalEventDraft) {
				classes += " externalEventDraft";
			}
			// @ts-expect-error
			if (this.proposedDraft.voting_finished) {
				classes += " proposedDraft-decided";
			}
			return classes;
		},
		isExternalEventDraft: function () {
			if (!this.proposedDraft) {
				return false;
			}
			return (
				// @ts-expect-error
				this.proposedDraft.attached_measures[0].ex_machina_phase_index !== null
			);
		},
		userVoted: function () {
			return (
				this.proposedDraft &&
				// @ts-expect-error
				this.proposedDraft.ratings.find(
					(rating) => rating.actor_id == this.currentActorId,
				) !== undefined
			);
		},
	},
	methods: {
		closeDraft() {
			pp.vue.bus.$emit("draft-CLOSE", this.proposedDraft);
			this.postDecidedTimeoutIsFinished = false;
			// @ts-expect-error
			window.clearInterval(this.autoCloseCountdown);
			this.autoCloseCountdown = null;
			this.autoCloseCountdownSeconds = 5;
		},
		filterRatings(ratingVal) {
			return window._.filter(
				// @ts-expect-error
				this.proposedDraft.ratings,
				(rating) => rating.rating == ratingVal,
			);
		},
		voteDraft(e, rating) {
			this.processingUserVote = true;
			const params = {
				rating: { rating: rating },
			};
			// @ts-expect-error
			$.post(`/drafts/${this.proposedDraft.id}/ratings.js`, params, (res) => {
				this.processingUserVote = false;
			});
		},
		initVotingModalCloseCountdown() {
			this.clearCountDownInterval();
			// @ts-expect-error
			this.autoCloseCountdown = window.setInterval(() => {
				if (this.autoCloseCountdownSeconds == 1) {
					this.closeDraft();
				} else {
					this.autoCloseCountdownSeconds -= 1;
				}
			}, 1000);
		},
		clearCountDownInterval() {
			// pp.log("Clearing autoclose countdown");
			// @ts-expect-error
			window.clearInterval(this.autoCloseCountdown);
			if (this.autoCloseCountdown != null) {
				this.autoCloseCountdown = null;
			}
		},
	},
};
</script>
